import {
  useLocation as useRRLocation,
  Navigate as RRNavigate,
} from "react-router";

const Navigate = ({ to, ...options }) => {
  const location = useRRLocation();

  return <RRNavigate to={`${to}${location.search}`} {...options} />;
};

export default Navigate;
